var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.loadingMsg))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }